export const Documentation = () => import("@/views/Static/Documentation/Documentation.vue");
export const Home = () => import("@/views/Home/Home.vue");
export const NotFound = () => import("@/views/Errors/404");
export const ServerError = () => import("@/views/Errors/500");
export const Record = () => import("@/views/Records/Record");
export const Records = () => import("@/views/Records/Records");
export const NewRecord = () => import("@/views/CreateRecord/NewRecord");
export const Editor = () => import("@/views/CreateRecord/Editor");
// export const Login = () => import("@/views/Users/Login/Login");
export { default as Login } from "@/views/Users/Login/Login.vue";
export const Signup = () => import("@/views/Users/Signup");
export const ConfirmAccount = () => import("@/views/Users/ConfirmAccount.vue");
export const ResendConfirmation = () =>
  import("@/views/Users/ResendConfirmation.vue");
export const User = () => import("@/views/Users/User.vue");
export const PublicProfile = () => import("@/views/Users/PublicProfile");
export const Curator = () => import("@/views/Curators/Curator.vue");
export const RequestNewPassword = () =>
  import("@/views/Users/RequestNewPassword");
export const ResetPassword = () => import("@/views/Users/ResetPassword");
export const EditProfile = () => import("@/views/Users/EditProfile");
export const EditPublicProfile = () =>
  import("@/views/Users/EditPublicProfile");
export const UsersList = () => import("@/views/Users/UsersList");
export const OauthLogin = () => import("@/views/Users/Login/OauthLogin.vue");
export const Organisation = () => import("@/views/Organisations/Organisation");
export const LoginFailure = () => import("@/views/Users/Login/LoginFailure");
export const Stat = () => import("@/views/Static/Stats/Statistics.vue");
export const Community = () => import("@/views/Static/Community/Community");
export const CommunityCuration = () =>
  import("@/views/Static/CommunityCuration/CommunityCuration");
export const CuratorCohorts = () =>
  import("@/views/Static/CommunityCuration/CuratorCohorts");
export const Stakeholders = () =>
  import("@/views/Static/Stakeholders/Stakeholders");
export const Timeline = () => import("@/views/Static/Timeline/Timeline");
export const Licence = () => import("@/views/Static/Licence/Licence");
export const Terms = () => import("@/views/Static/TermOfUse/TermsOfUse");
export const Educational = () =>
  import("@/views/Static/Educational/Educational");
export const Privacy = () => import("@/views/Static/Privacy/Privacy");
export const New = () => import("@/views/Static/New/New");
export const Graph = () => import("@/views/Records/NetworkGraph");
export const Maintenance = () => import("@/views/Errors/Maintenance");
export const APIDoc = () => import("@/views/Static/APIDoc/APIDoc");
export const OntologyBrowser = () => import("@/views/Browsers/OntologyBrowser");
export const OrganisationsList = () =>
  import("@/views/Organisations/OrganisationsList");
export const SustainabilityAndPreservation = () =>
  import(
    "@/views/Static/SustainabilityAndPreservation/SustainabilityAndPreservation.vue"
  );
export const AdvancedSearchRecords = () =>
  import("@/views/AdvancedSearch/AdvancedSearchRecordsView.vue");
export const SendOrcidLoginEmail = () =>
  import("@/views/Users/SendOrcidLoginEmail");
